import API from '../../helpers/API';
import { SHOW_LOADER, HIDE_LOADER, SET_MENU_ITMES, SET_HOME_DATA, SET_ALL_LANGUAGES_LIST, SET_WEB_LANGUAGE, SET_CAPTCHA_IMAGE } from '../../common/constants/ActionTypes';
import { OTPS, GET_MENU_ITEMS, GET_HOME_DATA, GET_ALL_LANGUAGES_LIST } from '../../common/constants/endpoints';
import { toastr } from 'react-redux-toastr';
import CryptoJS from 'crypto-js';
import CRC32 from 'crc-32';
const SECRET_KEY = "S300cr3t!@#Key$%^&*()_+[]{}|;':,.<>?/~`";

export function generateCRC(config) {

  const secretKey = SECRET_KEY;
  if (config?.data?.encryptedReqBody) {

    const encryptedBody = config.data.encryptedReqBody;

    const dataWithSecret = encryptedBody + secretKey;

    const crcValue = CRC32.str(dataWithSecret);

    return (crcValue >>> 0).toString(16);
  }
  if (config && config.data) {

    const requestBody = JSON.stringify(config.data);

    const dataWithSecret = encryptData(requestBody) + secretKey;

    const crcValue = CRC32.str(dataWithSecret);

    return (crcValue >>> 0).toString(16);
  }
  const crcValue = CRC32.str(secretKey);
  return (crcValue >>> 0).toString(16);
}
const decryptKey = CryptoJS.enc.Utf8.parse('1234567812345678');
const decryptIV = CryptoJS.enc.Utf8.parse('1234567812345678');
export function encryptData(data) {
    try {
        const encrypted = CryptoJS.AES.encrypt(data, decryptKey, {
            iv: decryptIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    } catch (error) {
        console.error("Encryption failed:", error);
        return null;
    }
}

export function decryptData(encryptedData) {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, decryptKey, {
            iv: decryptIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
}

export const generateCaptcha = () => {
  return async (dispatch) => {
        let response
        try {
            response = await API.post(OTPS, {
                type: "captcha",
            });

  if (response && response.data) {
                let captchaId = response.data.id;
                dispatch({
                    payload: captchaId,
                    type: SET_CAPTCHA_IMAGE,
                });
            }
        } catch (error) {
            dispatch({
                payload: response.data,
                type: SET_CAPTCHA_IMAGE,
            });
            // toastr.error(label.Error_while_generating, error.message);
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

// export const generateCaptcha = () => {
//   return async (dispatch) => {
//     try {
//       const response = await API.post(OTPS, {
//         type: "captcha",
//       });

//       dispatch({
//         type: SET_CAPTCHA_IMAGE,
//         payload: response.data.id, // captchaId
//       });
//     } catch (error) {
//       toastr.error(
//         error.response?.data?.message || error.message
//       );
//     }
//   };
// };

// export const generateCaptcha = () => {
//   return async (dispatch) => {
//     const res = await API.post(OTPS, { type: "captcha" });
//     dispatch({
//       type: SET_CAPTCHA_IMAGE,
//       payload: res.data.id
//     });
//   };
// };


export const showLoader = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOADER
        })
    }
};

export const hideLoader = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOADER
        })
    }
};

export const getMenuItems = () => {

    return async function (dispatch) {
        let response;
        try {
            response = await API.get(GET_MENU_ITEMS, {

            });
            if (response != null) {
                // dispatch(hideLoader());
            }
            dispatch({
                type: SET_MENU_ITMES,
                payload: response.data,
            });

        } catch (error) {
            // dispatch(hideLoader());
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getHomePageData = () => {

    return async function (dispatch) {
        dispatch(showLoader());
        let response;
        try {
            response = await API.get(GET_HOME_DATA, {

            });
            if (response != null) {
                // dispatch(hideLoader());
            }
            dispatch({
                type: SET_HOME_DATA,
                payload: response.data,
            });

        } catch (error) {
            // dispatch(hideLoader());
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}


export const getAllLanguagesList = () => {
    return async function (dispatch) {
        dispatch(showLoader());
        let response;
        let token = sessionStorage.getItem("token");
        try {
            response = await API.get(`${GET_ALL_LANGUAGES_LIST}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response != null) {
                dispatch(hideLoader());
            }
            dispatch({
                type: SET_ALL_LANGUAGES_LIST,
                payload: response.data,
            });
            if (response.data.languageConfigDtos && response.data.languageConfigDtos.length > 0) {
                let randomActiveLanguage = response.data.languageConfigDtos.find((lngdata) => lngdata.isActive === true)
                let allActiveLanguages = response.data.languageConfigDtos.filter(lngdata => lngdata.isActive === true).map(lang => lang.language)
                if (window.sessionStorage.getItem('userLanguage') === "" || !(allActiveLanguages.includes(window.sessionStorage.getItem('userLanguage')))) {
                    dispatch({
                        type: SET_WEB_LANGUAGE,
                        payload: randomActiveLanguage.language,
                    })
                }

            }
        } catch (error) {
            dispatch(hideLoader());
            let errorMessage =
                error.response && error.response.data
                    ? error.response.data.message
                    : error.message;
            toastr.error(errorMessage);
            return;
        }
    };
};
